import { useState } from "react";
import { ErrorMessage, Field } from "formik";

const FormSlugTextField = ({
  label = "textField",
  labelClassName = "",
  name = "textField",
  className = "",
  placeholder = "",
  type = "text",
  required,
  maxLength = null,
  slugValue = "",
  slugStatus,
  setSlugStatus = () => {},
  checkSlugApi = () => {},
  ...props
}) => {
  const [slugTimer, setSlugTimer] = useState(null);

  return (
    <div className="w-full">
      <Field name={name}>
        {({ field, meta, form }) => (
          <div className={`flex flex-col gap-1 ${className} w-full`}>
            {label && (
              <label
                htmlFor={name}
                className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${
                  meta.touched && meta.error
                    ? "text-errorColor"
                    : labelClassName
                }`}
              >
                {label}
              </label>
            )}

            <input
              {...field}
              {...props}
              id={name}
              name={name}
              type={type}
              maxLength={maxLength}
              placeholder={placeholder}
              required={required || slugStatus === "exists"}
              className={`px-3 py-2 w-full rounded-lg border-[1px]
  text-fs_14 text-darkText placeholder-greyText focus:outline-none ${
    meta.touched && meta.error ? "border-errorColor" : "border-greyText"
  }`}
              onChange={(e) => {
                field.onChange(e);

                const value = e.target.value.trim();

                if (slugTimer) {
                  clearTimeout(slugTimer);
                }

                const timer = setTimeout(() => {
                  if (!value) {
                    setSlugStatus("");
                    form.setFieldError(name, "");
                    return;
                  }

                  // if slug unchanged in edit
                  if (slugValue && slugValue === value) {
                    setSlugStatus("");
                    form.setFieldError(name, "");
                    return;
                  }

                  checkSlugApi(value, form);
                }, 500);

                setSlugTimer(timer);
              }}
            />
            {/* Status message */}

            {slugStatus === "available" && (
              <span className="text-green-600 text-sm">Slug available</span>
            )}

            <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
              <ErrorMessage name={name} />
            </label>
          </div>
        )}
      </Field>
    </div>
  );
};

export default FormSlugTextField;
